import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
} from "react-bootstrap";
import { DropdownFilter, HeadPage } from "src/componentes";
import SistemaCadastroCode from "./SistemaCadastro.Code";
import { UsuarioDto } from "../../Usuario/Usuario.Dto";
import { EConfiguracaoTipo } from "./SistemaCadastro.Dto";

const SistemaCadastroView = () => {
  const code = SistemaCadastroCode();

  return (
    <Container>
      <Form noValidate onSubmit={code.form.handleSubmit(code.onSubmit)}>
        <HeadPage headText="Cadastro de Configuração" />
        {!code.loading ? (
          <>
            <Row>
              <Col xs={12} sm={6} md={4} lg={4}>
                <Form.Group controlId="subModulo">
                  <Form.Label>Submódulo</Form.Label>
                  <Form.Select
                    {...code.form.register("subModulo", {
                      valueAsNumber: true,
                    })}
                    onChange={(e) => {
                      code.form.setValue("subModulo", Number(e.target.value));
                      code.form.setValue("tipoConfiguracao", undefined as any);
                    }}
                    isInvalid={!!code.form.formState.errors.subModulo}
                  >
                    <option value="">Selecione</option>
                    {code.subModuloOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {code.form.formState.errors.subModulo?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={4} lg={4}>
                <Form.Group controlId="configuracao">
                  <Form.Label>Configuração</Form.Label>
                  <Form.Select
                    {...code.form.register("tipoConfiguracao")}
                    onChange={(e) =>
                      code.form.setValue(
                        "tipoConfiguracao",
                        Number(e.target.value)
                      )
                    }
                    isInvalid={!!code.form.formState.errors.tipoConfiguracao}
                  >
                    <option value="">Selecione</option>
                    {code.subModulo &&
                      code.configuracaoOptions[code.subModulo]?.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {code.form.formState.errors.tipoConfiguracao?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <Form.Group controlId="valor">
                  <Form.Label>Valor</Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={
                      Number(code.form.watch("tipoConfiguracao")) ===
                      EConfiguracaoTipo.RNTRC
                        ? 8
                        : 60
                    }
                    {...code.form.register("configuracaoValor")}
                    isInvalid={!!code.form.formState.errors.configuracaoValor}
                  />
                  {Number(code.form.watch("tipoConfiguracao")) ===
                    EConfiguracaoTipo.RNTRC && (
                    <Form.Text className="text-muted">
                      Informe até 8 dígitos numéricos.
                    </Form.Text>
                  )}
                  <Form.Control.Feedback type="invalid">
                    {code.form.formState.errors.configuracaoValor?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {Number(code.form.watch("tipoConfiguracao")) ===
              EConfiguracaoTipo.Serie && (
              <Row>
                <Col xs={12}>
                  <DropdownFilter<UsuarioDto>
                    fetchData={code.consultarUsuario.UsuarioBuscar}
                    loading={code.consultarUsuario.loading}
                    labelDescription="Usuário"
                    getDescription={(item: UsuarioDto) => item.nome}
                    getId={(item: UsuarioDto) => item.id}
                    registeredFields={{
                      id: code.form.register("usuarioId"),
                      description: code.form.register("usuarioNome"),
                    }}
                    errorsMessageDescription={
                      code.form.formState.errors.usuarioId
                    }
                    onSelect={(item: UsuarioDto | undefined) => {
                      if (item !== undefined) {
                        code.form.setValue("usuarioId", item.id);
                        code.form.setValue("usuarioNome", item.nome);
                      } else {
                        code.form.setValue("usuarioId", undefined);
                        code.form.setValue("usuarioNome", "");
                      }
                    }}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button type="submit">Confirmar</Button>
              </Col>
            </Row>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default SistemaCadastroView;
